import utagLinkGeneric from './utagLinkGeneric';

function utagLinkPLA (eventCategory = 'PLA') {

	return ({ eventAction, eventLabel = '', nonInteraction = 0 }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel,
			nonInteraction
		});

	};

}

export default utagLinkPLA;
